// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__yb333","image":"Icon_image__xeZrv"};